import dayjs from "dayjs";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import Segmented, { SEGMENTED_VARIANTS } from "./Segmented";

const DATE_INPUT_FORMAT = "YYYY-MM-DD";

export const firstExpiryDate = () =>
  dayjs().add(1, "day").format(DATE_INPUT_FORMAT);

export const isExpiryValid = (expiry) =>
  !expiry.on || (!isEmpty(expiry.date) && expiry.date >= firstExpiryDate());

export const expiryDateOf = (expiry) =>
  expiry.on ? new Date(expiry.date).toISOString() : null;

const ExpiryPicker = ({ id, expiry, labels, choices, onChange }) => (
  <>
    <Segmented
      variant={SEGMENTED_VARIANTS.NARROW}
      value={expiry.on}
      options={choices.map((on) => ({
        value: on,
        label: on ? labels.ON_DATE : labels.NEVER,
      }))}
      onChange={(on) => onChange({ ...expiry, on })}
    />
    {expiry.on ? (
      <div className="onboarding__field onboarding__field--narrow">
        <label htmlFor={id}>{labels.DATE}</label>
        <input
          id={id}
          type="date"
          min={firstExpiryDate()}
          className="onboarding__input"
          value={expiry.date}
          onChange={({ target }) => onChange({ ...expiry, date: target.value })}
        />
      </div>
    ) : null}
    <p className="onboarding__hint">{labels.EXPIRY_HINT}</p>
  </>
);

ExpiryPicker.propTypes = {
  id: PropTypes.string.isRequired,
  expiry: PropTypes.shape({
    on: PropTypes.bool,
    date: PropTypes.string,
  }).isRequired,
  labels: PropTypes.object.isRequired,
  choices: PropTypes.arrayOf(PropTypes.bool).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ExpiryPicker;
